import axios from "axios";
import instance,{BASE_URL} from "../../services/api";

const TaxApiViewController =()=>{
    const getTaxSlab = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}taxslabs/`,
         );
      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_TAX_SLAB_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "GET_TAX_SLAB_FAILURE",
        payload: { error: error }
      });
    }
  };

  const addTaxSlab = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}taxslabs/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_TAX_SLAB_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getTaxSlab());
      return data ; 

    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "ADD_TAX_SLAB_FAILURE",
        payload: { error: error }
      });
    }
  };

  const updateTaxSlab = (taxslabId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}taxslabs/${taxslabId}/`,
        reqData
      );
      const data = response.data;
      // const jsonString = JSON.stringify(response.data);
      // const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_TAX_SLAB_SUCCESS", payload: data });
      dispatch(getTaxSlab());
      dispatch({ type: "LOADING", payload: false });
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "UPDATE_TAX_SLAB_FAILURE",
        payload: { error: error },
      });
    }
  };

  const deleteTaxSlab = (taxslabId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}taxslabs/${taxslabId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_TAX_SLAB_SUCCESS", payload: data });
      dispatch(getTaxSlab());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "DELETE_TAX_SLAB_FAILURE",
        payload: { error: error },
      });
    }
  };

  return{
    getTaxSlab, addTaxSlab, updateTaxSlab,deleteTaxSlab
  };


}

export default TaxApiViewController;